
(() => {
  const initSticky = () => {
    const bar = document.querySelector('[data-twiggy-sticky-atc]');
    const form = document.querySelector('product-info form[action*="/cart/add"]');
    const primary = form?.querySelector('[name="add"]');
    if (!bar || !form || !primary) return;
    const button = bar.querySelector('button');
    const price = bar.querySelector('[data-sticky-price]');
    const sync = () => {
      button.disabled = primary.disabled;
      button.textContent = primary.querySelector('span')?.textContent?.trim() || primary.textContent.trim() || 'Add to cart';
      const livePrice = document.querySelector('product-info .price .price-item--regular, product-info .price .price-item--sale');
      if (livePrice && price) price.textContent = livePrice.textContent.trim();
      bar.dataset.ready = 'true';
    };
    button.addEventListener('click', () => primary.click());
    new MutationObserver(sync).observe(primary, { attributes: true, childList: true, subtree: true });
    document.addEventListener('variant:change', sync);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky, { once: true });
  else initSticky();
})();
